/**
 * traction-react URLs for the multi-dashboard revamp (model tab + per-pack routes).
 * blox-bi API paths stay under `/dashboard/{uuid}` — this module is browser routing only.
 */

export const DASHBOARDS_TAB_SEGMENT = 'dashboards';
/** Legacy model tab segment; redirects to {@link DASHBOARDS_TAB_SEGMENT}. */
export const LEGACY_DASHBOARD_TAB_SEGMENT = 'dashboard';

export type ModelDashboardRouteMode = 'dashboards-index' | 'dashboard-detail';

export interface ParsedModelDashboardRoute {
  modelId: string;
  mode: ModelDashboardRouteMode;
  dashboardId: string | null;
}

/** `/model/:modelId/dashboards` — resolves to a concrete pack via redirect logic. */
export function buildModelDashboardsTabUrl(modelId: number | string): string {
  return `/model/${modelId}/${DASHBOARDS_TAB_SEGMENT}`;
}

/**
 * Canonical live dashboard URL. `pageId` is optional; when omitted the UI selects the first page.
 */
export function buildModelDashboardUrl(
  modelId: number | string,
  dashboardId: string,
  pageId?: string | number | null,
): string {
  const base = `/model/${modelId}/dashboard/${encodeURIComponent(dashboardId)}`;
  if (pageId === undefined || pageId === null || pageId === '') {
    return base;
  }
  return `${base}?pageId=${encodeURIComponent(String(pageId))}`;
}

export function parseModelDashboardPath(pathname: string): ParsedModelDashboardRoute | null {
  const detail = pathname.match(/^\/model\/([^/]+)\/dashboard\/([^/]+)\/?$/);
  if (detail) {
    return {
      modelId: detail[1],
      mode: 'dashboard-detail',
      dashboardId: decodeURIComponent(detail[2]),
    };
  }
  const index = pathname.match(/^\/model\/([^/]+)\/dashboards\/?$/);
  if (index) {
    return {
      modelId: index[1],
      mode: 'dashboards-index',
      dashboardId: null,
    };
  }
  return null;
}

export function isLegacyDashboardTabSegment(tab: string | undefined | null): boolean {
  return tab === LEGACY_DASHBOARD_TAB_SEGMENT;
}
